import type { CentrifugeMessage, CentrifugeMessageType } from './messageTypes';
import type {
  PersonalAdminMessage,
  PersonalManagerOnOffMessage,
  PersonalMissionMessageMessage,
  PersonalOverLapLoginMessage,
  PersonalRefreshTokenMessage,
  PersonalSupportMessage,
  PersonalUpdateUserInfoMessage,
  PersonalUserAlertMessage,
  PersonalUserStopMessage,
} from './personalMessageTypes';
import type {
  AdminChatMessage,
  BlindOffMessage,
  BlindOnMessage,
  BookmarkAlertMessage,
  CastGuestImgBlindOnMessage,
  ChatBlockCountryMessage,
  ChatIntroMessage,
  ChatServerDisconnectMessage,
  CorrectCaptionMessage,
  CustomMuteOnMessage,
  EventAnimCoinMessage,
  ExcelSponCoinMessage,
  FanInMessage,
  FanUpMessage,
  FreezeOffMessage,
  FreezeOnMessage,
  FrozenMessage,
  InfoMessage,
  IntendedAlertMessage,
  IntroEffectMessage,
  ItemCoinMessage,
  KingFanInMessage,
  KingFanUpMessage,
  LayoutChatMessage,
  LiveRoomRankMessage,
  ManagerInMessage,
  ManagerOffMessage,
  ManagerOnMessage,
  MemberKickOutMessage,
  MissionMessage,
  MuteOffMessage,
  MuteOnMessage,
  NormalChatMessage,
  RecommendMessage,
  ServiceBlindOffMessage,
  ServiceBlindOnMessage,
  ServiceCastBlockMessage,
  SponCoinMessage,
  VipInMessage,
} from './public-message';

export type ChatUIAffectingMessage =
  | LiveRoomRankMessage
  | RecommendMessage
  | SponCoinMessage
  | ExcelSponCoinMessage
  | NormalChatMessage
  | InfoMessage
  | FanInMessage
  | ItemCoinMessage
  | ManagerInMessage
  | KingFanInMessage
  | FanUpMessage
  | KingFanUpMessage
  | VipInMessage
  | IntroEffectMessage
  | FreezeOnMessage
  | FreezeOffMessage
  | FrozenMessage
  | ManagerOffMessage
  | ManagerOnMessage
  | MemberKickOutMessage
  | MuteOffMessage
  | MuteOnMessage
  | CustomMuteOnMessage
  | CastGuestImgBlindOnMessage
  | BlindOnMessage
  | BlindOffMessage
  | ServiceBlindOnMessage
  | ServiceBlindOffMessage
  | MissionMessage
  | IntendedAlertMessage
  | BookmarkAlertMessage
  | LayoutChatMessage
  | EventAnimCoinMessage
  | ChatIntroMessage
  | ChatServerDisconnectMessage
  | AdminChatMessage
  | CorrectCaptionMessage
  | ChatBlockCountryMessage
  | ServiceCastBlockMessage
  | PersonalAdminMessage
  | PersonalSupportMessage
  | PersonalManagerOnOffMessage
  | PersonalMissionMessageMessage
  | PersonalOverLapLoginMessage
  | PersonalRefreshTokenMessage
  | PersonalUpdateUserInfoMessage
  | PersonalUserAlertMessage
  | PersonalUserStopMessage;

export const chatTypes = [
  'bj',
  'manager',
  'chatter',
  'admin',
  'police',
  'support',
  'personal',
  'SponCoin',
  'Recommend',
  'Info',
  'FanIn',
  'KingFanIn',
  'ItemCoin',
  'ManagerIn',
  'FanUp',
  'KingFanUp',
  'LiveRoomRank',
  'IntroEffect',
  'FreezeOn',
  'FreezeOff',
  'Frozen',
  'ManagerOn',
  'ManagerOff',
  'MuteOff',
  'MuteOn',
  'CustomMuteOn',
  'MemberKickOut',
  'BlindOn',
  'BlindOff',
  'ServiceBlindOn',
  'ServiceBlindOff',
  'CastGuestImgBlindOn',
  'VipIn',
  'Mission',
  'LayoutChat',
  'EventAnimCoin',
  'ChatIntro',
  'ChatServerDisconnect',
  'correctCaption',
  'ChatBlockCountry',
  'ServiceCastBlock',
] as const;

export const chatTypesSet: Set<CentrifugeMessageType> = new Set(chatTypes);

export const isChatMessage = (item: CentrifugeMessage): item is ChatUIAffectingMessage => {
  return 'data' in item && chatTypesSet.has(item.data.type);
};
